module.exports = __webpack_public_path__ + "img/150-11.9337e017.jpg";